"use strict";

var _regeneratorRuntime = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/createClass.js");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.url.to-json");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _axios = _interopRequireDefault(require("axios"));

var _jsonStringifySafe = _interopRequireDefault(require("json-stringify-safe"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var axiosInstance = _axios.default.create({
  transformRequest: [function (data) {
    if (typeof data === 'string' || data instanceof String) {
      return data;
    }

    return JSON.stringify(data);
  }]
});

var DEFAULT_INTERVAL = 0;
var DEFAULT_BATCH = 0;

var NOOP = function NOOP() {};

function getUUID() {
  // eslint gets funny about bitwise

  /* eslint-disable */
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var piece = Math.random() * 16 | 0;
    var elem = c === "x" ? piece : piece & 0x3 | 0x8;
    return elem.toString(16);
  });
  /* eslint-enable */
}

function formatDate(date) {
  return date.toJSON();
}

function stringifySafe(obj) {
  function filterUnserializableNodes(_, value) {
    switch (typeof value) {
      case "bigint":
      case "symbol":
        // These two are rarely used, but bigint will fail if you try to stringify it.
        // Symbol is returned as undefined, but if we happen to try to log one, it'd be
        // nice to know what it is.
        return value.toString();

      default:
        return value;
    }
  }

  return (0, _jsonStringifySafe.default)(obj, filterUnserializableNodes);
}

var SumoLogger = /*#__PURE__*/function () {
  function SumoLogger(options) {
    _classCallCheck(this, SumoLogger);

    if (!options || !Object.prototype.hasOwnProperty.call(options, "endpoint") || options.endpoint === undefined || options.endpoint === "") {
      console.error("An endpoint value must be provided");
      return;
    }

    this.config = {};
    this.pendingLogs = [];
    this.interval = 0;
    this.logSending = false;
    this.setConfig(options);
    this.startLogSending();
  }

  _createClass(SumoLogger, [{
    key: "setConfig",
    value: function setConfig(newConfig) {
      this.config = {
        endpoint: newConfig.endpoint,
        returnPromise: Object.prototype.hasOwnProperty.call(newConfig, "returnPromise") ? newConfig.returnPromise : true,
        clientUrl: newConfig.clientUrl || "",
        useIntervalOnly: newConfig.useIntervalOnly || false,
        interval: newConfig.interval || DEFAULT_INTERVAL,
        batchSize: newConfig.batchSize || DEFAULT_BATCH,
        sourceName: newConfig.sourceName || "",
        hostName: newConfig.hostName || "",
        sourceCategory: newConfig.sourceCategory || "",
        session: newConfig.sessionKey || getUUID(),
        onSuccess: newConfig.onSuccess || NOOP,
        onError: newConfig.onError || NOOP,
        graphite: newConfig.graphite || false,
        raw: newConfig.raw || false
      };
    }
  }, {
    key: "updateConfig",
    value: function updateConfig() {
      var newConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (newConfig.endpoint) {
        this.config.endpoint = newConfig.endpoint;
      }

      if (newConfig.returnPromise) {
        this.config.returnPromise = newConfig.returnPromise;
      }

      if (newConfig.useIntervalOnly) {
        this.config.useIntervalOnly = newConfig.useIntervalOnly;
      }

      if (newConfig.interval) {
        this.config.interval = newConfig.interval;
        this.startLogSending();
      }

      if (newConfig.batchSize) {
        this.config.batchSize = newConfig.batchSize;
      }

      if (newConfig.sourceCategory) {
        this.config.sourceCategory = newConfig.sourceCategory;
      }
    }
  }, {
    key: "batchReadyToSend",
    value: function batchReadyToSend() {
      if (this.config.batchSize === 0) {
        return this.config.interval === 0;
      } else {
        var pendingMessages = this.pendingLogs.reduce(function (acc, curr) {
          var log = JSON.parse(curr);
          return acc + log.msg + "\n";
        }, "");
        var pendingBatchSize = pendingMessages.length;
        var ready = pendingBatchSize >= this.config.batchSize;

        if (ready) {
          this.stopLogSending();
        }

        return ready;
      }
    }
  }, {
    key: "_postSuccess",
    value: function _postSuccess(logsSentLength) {
      this.pendingLogs = this.pendingLogs.slice(logsSentLength); // Reset interval if needed:

      this.startLogSending();
      this.config.onSuccess();
    }
  }, {
    key: "sendLogs",
    value: function sendLogs() {
      var _this2 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          isFlushing = _ref.isFlushing;

      if (this.logSending || this.pendingLogs.length === 0) {
        return false;
      }

      try {
        this.logSending = true;
        var headers = {
          "X-Sumo-Client": "sumo-javascript-sdk"
        };

        if (this.config.graphite) {
          Object.assign(headers, {
            "Content-Type": "application/vnd.sumologic.graphite"
          });
        } else {
          Object.assign(headers, {
            "Content-Type": "application/json"
          });
        }

        if (this.config.sourceName !== "") {
          Object.assign(headers, {
            "X-Sumo-Name": this.config.sourceName
          });
        }

        if (this.config.sourceCategory !== "") {
          Object.assign(headers, {
            "X-Sumo-Category": this.config.sourceCategory
          });
        }

        if (this.config.hostName !== "") {
          Object.assign(headers, {
            "X-Sumo-Host": this.config.hostName
          });
        }

        var logsToSend = Array.from(this.pendingLogs).join("\n");
        var axiosConfig = {
          headers: headers,
          maxContentLength: Infinity,
          maxBodyLength: Infinity
        };

        if (this.config.returnPromise && this.pendingLogs.length === 1) {
          return axiosInstance.post(this.config.endpoint, logsToSend, axiosConfig).then(function (res) {
            _this2._postSuccess(1);

            _this2.logSending = false;
            return res;
          }).catch(function (error) {
            _this2.config.onError(error);

            _this2.logSending = false;

            if (isFlushing) {
              _this2.stopLogSending();

              console.error("Flushing logs failed");
            } else {
              console.error("Logs ".concat(JSON.stringify(logsToSend, null, 2), " failed to be sent"));

              _this2.removeFromPendingLogs(logsToSend.length);
            }

            return Promise.reject(error);
          });
        }

        return axiosInstance.post(this.config.endpoint, logsToSend, axiosConfig).then(function () {
          _this2._postSuccess(logsToSend.length);

          _this2.logSending = false;
        }).catch(function (error) {
          _this2.config.onError(error);

          _this2.logSending = false;

          if (isFlushing) {
            _this2.stopLogSending();

            console.error("Flushing logs failed");
          } else {
            console.error("Logs ".concat(JSON.stringify(logsToSend, null, 2), " failed to be sent"));

            _this2.removeFromPendingLogs(logsToSend.length);
          }

          if (_this2.config.returnPromise) {
            return Promise.reject(error);
          }
        });
      } catch (ex) {
        this.config.onError(ex);
        return false;
      }
    }
  }, {
    key: "startLogSending",
    value: function startLogSending() {
      var _this = this;

      if (this.config.interval > 0) {
        if (this.interval) {
          this.stopLogSending();
        }

        this.interval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return _this.sendLogs();

                case 3:
                  _context.next = 8;
                  break;

                case 5:
                  _context.prev = 5;
                  _context.t0 = _context["catch"](0);
                  console.error("Interval Sending logs failed", _context.t0);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 5]]);
        })), this.config.interval);
      }
    }
  }, {
    key: "stopLogSending",
    value: function stopLogSending() {
      clearInterval(this.interval);
    }
  }, {
    key: "removeFromPendingLogs",
    value: function removeFromPendingLogs(logsToRemoveLength) {
      this.pendingLogs = this.pendingLogs.slice(logsToRemoveLength);
    }
  }, {
    key: "emptyLogQueue",
    value: function emptyLogQueue() {
      this.pendingLogs = [];
    }
  }, {
    key: "flushLogs",
    value: function flushLogs() {
      return this.sendLogs({
        isFlushing: true
      });
    }
  }, {
    key: "log",
    value: function log(msg, optionalConfig) {
      var _this3 = this;

      var message = msg;

      if (!message) {
        console.error("A value must be provided");
        return false;
      }

      var isArray = message instanceof Array;
      var testEl = isArray ? message[0] : message;
      var type = typeof testEl;

      if (type === "undefined") {
        console.error("A value must be provided");
        return false;
      }

      if (this.config.graphite && (!Object.prototype.hasOwnProperty.call(testEl, "path") || !Object.prototype.hasOwnProperty.call(testEl, "value"))) {
        console.error('Both "path" and "value" properties must be provided in the message object to send Graphite metrics');
        return false;
      }

      if (type === "object") {
        if (Object.keys(message).length === 0) {
          console.error("A non-empty JSON object must be provided");
          return false;
        }
      }

      if (!isArray) {
        message = [message];
      }

      var ts = new Date();
      var sessKey = this.config.session;
      var client = {
        url: this.config.clientUrl
      };

      if (optionalConfig) {
        if (Object.prototype.hasOwnProperty.call(optionalConfig, "sessionKey")) {
          sessKey = optionalConfig.sessionKey;
        }

        if (Object.prototype.hasOwnProperty.call(optionalConfig, "timestamp")) {
          ts = optionalConfig.timestamp;
        }

        if (Object.prototype.hasOwnProperty.call(optionalConfig, "url")) {
          client.url = optionalConfig.url;
        }
      }

      var timestamp = formatDate(ts);
      var messages = message.map(function (item) {
        if (_this3.config.graphite) {
          return "".concat(item.path, " ").concat(item.value, " ").concat(Math.round(ts.getTime() / 1000));
        }

        if (_this3.config.raw) {
          return item;
        }

        if (typeof item === "string") {
          return stringifySafe(Object.assign({
            msg: item,
            sessionId: sessKey,
            timestamp: timestamp
          }, client));
        }

        var current = {
          sessionId: sessKey,
          timestamp: timestamp
        };
        return stringifySafe(Object.assign(current, client, item));
      });
      this.pendingLogs = this.pendingLogs.concat(messages);

      if (!this.config.useIntervalOnly && this.batchReadyToSend()) {
        return this.sendLogs();
      }
    }
  }]);

  return SumoLogger;
}();

exports.default = SumoLogger;
module.exports = exports.default;